import styled from 'styled-components';
import { Trans } from 'services/i18n';
import { ErrorStatePageError } from 'ui/illustrations/ErrorStatePageError';
import { colors, duration, easing, fontSizes, fontWeights, spacing } from 'ui/theme';
import { StyledRouterLink } from 'ui/links';

import { useTranslations } from '../../hooks/useTranslations';

const CtaHeader = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s20};
  font-weight: ${fontWeights.semiBold};
`;

const Cta = styled.div`
  font-size: ${fontSizes.s16};
`;

const EmptyState = styled.div`
  align-items: stretch;
  border-color: ${colors.grey15};
  border-radius: ${spacing.quarter};
  border-style: solid;
  border-width: ${spacing.single};
  color: ${colors.textSecondary};
  display: flex;
  height: 100%;
  min-height: fit-content;
  flex-direction: column;
  justify-content: center;
  padding: ${spacing.plusHalf};
  position: initial;
  row-gap: ${spacing.base};
  transition: all ${duration.short} ${easing.entrance};
`;

const StyledLabel = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.regular};
  row-gap: ${spacing.base};
  text-align: center;
  white-space: pre-wrap;
  height: fit-content;
`;

export const DATA_TEST = {
  emptyState: 'mi-block-integration-empty-state',
};

export const EmptyIntegrationsState = () => {
  const { t } = useTranslations();
  const ctaHeader = t('emptyState.noIntegrations.header');

  return (
    <EmptyState data-test={DATA_TEST.emptyState}>
      <StyledLabel>
        <ErrorStatePageError />
        <CtaHeader>{ctaHeader}</CtaHeader>
        <Cta>
          <Trans
            t={t}
            i18nKey="emptyState.noIntegrations.message"
            components={{
              href: <StyledRouterLink to={{ pathname: '/integrations/movableInkIntegration' }} />,
            }}
          >
            <StyledRouterLink to={{ pathname: '/integrations/movableInkIntegration' }}>
              add a connection.
            </StyledRouterLink>
          </Trans>
        </Cta>
      </StyledLabel>
    </EmptyState>
  );
};
